import moment from 'moment';
import { dateDiff } from '../../utils/commonUtil';

export const isNewAdvent = (daAggrs) => {
    let dateDiffArr = [];
    const todaysDate = new Date();
    if(daAggrs && daAggrs.length) {
        daAggrs.forEach(agg => {
            if(agg.authDate) {
                let diff = dateDiff(agg.authDate, todaysDate);
                dateDiffArr.push(diff);
            }
        });
    }
    if(dateDiffArr && dateDiffArr.length) {
        return dateDiffArr && dateDiffArr.reduce((a, b) => Math.min(a, b)) < 90;
    } else {
        return null;
    }
    
}

export const sortAggrDates = (agg) => {
    if (agg && agg.length) {
        const datelessAggr = agg.filter(a => !a.authDate);
        let sortedArr = [];
        if (datelessAggr && datelessAggr.length) {
            const dateAggr = agg.filter(a => a.authDate).sort((a, b) =>
                new Date(moment(a.authDate, 'DD/MM/YYYY').format('YYYY-MM-DD')) - new Date(moment(b.authDate, 'DD/MM/YYYY').format('YYYY-MM-DD')));;
                sortedArr.push(...datelessAggr, ...dateAggr);
                return sortedArr
        } else {
            sortedArr = agg.sort((a, b) =>
                new Date(moment(a.authDate, 'DD/MM/YYYY').format('YYYY-MM-DD')) - new Date(moment(b.authDate, 'DD/MM/YYYY').format('YYYY-MM-DD')));
                return sortedArr;
        }
    }
    return [];
}